<template>
  <app-modal name="invoice-import-result-modal" :title="title" width="60%" :esc-to-close="false" @before-open="beforeOpen" @before-close="beforeClose"  hide-footer>
    <div class="row">
      <div class="col-lg-12 container-max-height-scroll-80">

        <ul class="tabs-component-tabs">
          <li v-if="successfullyInvoicesMap.total_invoices > 0" @click="activeTab = 'TAB_SUCCESSFULLY'" role="presentation" :class="{ 'is-active': activeTab === 'TAB_SUCCESSFULLY' }"
              class="tabs-component-tab">
              {{ $t("upload.successful") }} ({{successfullyInvoicesMap.total_invoices}})
          </li>
          <li  v-if="reconciledInvoicesMap.total_invoices > 0" @click="activeTab = 'TAB_RECONCILED'" role="presentation" :class="{ 'is-active': activeTab === 'TAB_RECONCILED' }"
               class="tabs-component-tab">
               {{ $t("upload.reconciled") }} ({{reconciledInvoicesMap.total_invoices}})
          </li>
          <li  v-if="NoOfInvalidInvoices > 0" @click="activeTab = 'TAB_INVALID'" role="presentation" :class="{ 'is-active': activeTab === 'TAB_INVALID' }"
               class="tabs-component-tab">
              {{ $t("upload.invalid") }} ({{NoOfInvalidInvoices}})
          </li>
        </ul>

        <div v-if="activeTab === 'TAB_SUCCESSFULLY'" class="row">
          <div class="col-md-12">
            <invoice-list
              :show-index="true"
              :show-filter="false"
              :allow-multi-select="false"
              :active-invoice="activeInvoice"
              :invoices="successfullyInvoicesMap.invoices"
              @on-click="onClickSuccessfullyInvoice"
            ></invoice-list>
          </div>
        </div>

        <div v-if="activeTab === 'TAB_RECONCILED'" class="row">
          <div class="col-md-12">
            <invoice-list
              :show-index="true"
              :show-filter="false"
              :allow-multi-select="false"
              :active-invoice="activeInvoice"
              :invoices="reconciledInvoicesMap.invoices"
              @on-click="onClickReconciledInvoice"
            ></invoice-list>
          </div>
        </div>

        <div v-if="activeTab === 'TAB_INVALID'" class="row">
          <div class="col-md-12">
            <ul v-if="NoOfInvalidInvoices" class="tabs-component-tabs ml-3">
              <template v-for="type in invoiceTypes">
                <li v-if="invalidInvoicesMap[type].total_invoices > 0" @click="activeSubTab = type" role="presentation" :class="{ 'is-active secondary': activeSubTab === type }"
                    class="tabs-component-tab">
                  {{ $t(`invoice.invoiceTypes.${type}`) }} ({{invalidInvoicesMap[type].total_invoices}})
                </li>
              </template>
            </ul>
              <invoice-list
                v-show="activeSubTab === 'FAILED'"
                :show-index="true"
                :show-filter="false"
                :allow-multi-select="false"
                :active-invoice="activeInvoice"
                :invoices="activeInvoicesByType"
                @on-click="onClickInvalidInvoice"
              ></invoice-list>

              <div v-show="activeSubTab === 'ERROR'" class="invoice-item" v-for="(invoice, index) in activeInvoicesByType" :key="index">
                <div class="d-flex">
                  <div style="flex-grow: 1">
                    <div class="invoice-number">
                      <span class="mr-auto">{{ $t('invoice.invoiceNumber') }}: {{invoice.invoice_number}} - {{ $t("invoice.invoiceCommonCode") }}: {{invoice.invoice_serial}}</span>
                      <label class="badge">
                        <span class="in" v-if="!invoice.kind_of">{{$t('invoice.income')}}</span>
                        <span class="out" v-if="invoice.kind_of">{{$t('invoice.outcome')}}</span>
                      </label>
                    </div>
                    <div class="invoice-title red">
                      <span>Lỗi: {{invoice.error}}</span>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>

<!--        <div v-if="activeTab === 'TAB_FAILED'" class="row">-->
<!--          <div class="col-md-12">-->
<!--            <template v-for="invoice in failedInvoices">-->
<!--              <div class="invoice-item">-->
<!--                <div class="d-flex">-->
<!--                  <div style="flex-grow: 1">-->
<!--                    <div class="invoice-number">-->
<!--                      <span class="mr-auto">{{ $t('invoice.invoiceNumber') }}: {{invoice.invoice_number}} - {{ $t("invoice.invoiceCommonCode") }}: {{invoice.invoice_serial}}</span>-->
<!--                      <label class="badge">-->
<!--                        <span class="in" v-if="!invoice.kind_of">{{$t('invoice.income')}}</span>-->
<!--                        <span class="out" v-if="invoice.kind_of">{{$t('invoice.outcome')}}</span>-->
<!--                      </label>-->
<!--                    </div>-->
<!--                    <div class="invoice-title red">-->
<!--                      <span>Lỗi: {{invoice.error}}</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </template>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import InvoiceList from '@/portal-components/invoice/invoice-list';
import { mapActions } from 'vuex';

const TABS = {
  TAB_INVALID: 'TAB_INVALID',
  TAB_RECONCILED: 'TAB_RECONCILED',
  TAB_SUCCESSFULLY: 'TAB_SUCCESSFULLY',
};

const INVOICE_TYPES = {
  FAILED: 'FAILED',
  ERROR: 'ERROR',
};

export default {
  name: 'InvoiceImportModal',
  components: {
    AppModal,
    InvoiceList,
  },
  data() {
    return {
      title: this.$t('invoice.import'),
      activeTab: TABS.TAB_DUPLICATED,
      activeSubTab: INVOICE_TYPES.FAILED,
      reconciledInvoicesMap: {},
      successfullyInvoicesMap: {},
      invalidInvoicesMap: {},
      NoOfInvalidInvoices: 0,
      activeInvoice: {},
      invoiceTypes: ['FAILED', 'ERROR'],
    };
  },
  computed: {
    activeInvoicesByType() {
      if (this.NoOfInvalidInvoices && this.invalidInvoicesMap[this.activeSubTab]) {
        return this.invalidInvoicesMap[this.activeSubTab].invoices;
      }
      return [];
    },
  },
  methods: {
    ...mapActions(['addErrorInvoices']),
    showInvoiceList(activeInvoice, invoices, index) {
      this.activeInvoice = activeInvoice;
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.$modal.show('invoice-form-modal', {
            invoiceList: invoices,
            currentIndex: index,
          });
        });
      });
    },
    // onClickDuplicatedInvoice(invoice, index) {
    //   this.showInvoiceList(invoice, this.duplicatedInvoices, index);
    // },
    // onClickVerifyInvoice(invoice, index) {
    //   this.showInvoiceList(invoice, this.verifiedInvoices, index);
    // },
    onClickInvalidInvoice(invoice, index) {
      this.showInvoiceList(invoice, this.activeInvoicesByType, index);
    },
    onClickReconciledInvoice(invoice, index) {
      this.showInvoiceList(invoice, this.reconciledInvoicesMap.invoices, index);
    },
    onClickSuccessfullyInvoice(invoice, index) {
      this.showInvoiceList(invoice, this.successfullyInvoicesMap.invoices, index);
    },
    beforeOpen(params) {
      // Reset các map và số lượng trước khi gán giá trị mới
      this.reconciledInvoicesMap = { invoices: [], total_invoices: 0 };
      this.successfullyInvoicesMap = { invoices: [], total_invoices: 0 };
      this.invalidInvoicesMap = { FAILED: { invoices: [], total_invoices: 0 }, ERROR: { invoices: [], total_invoices: 0 } };
      this.NoOfInvalidInvoices = 0;

      const {
        invoices_already_exist: alreadyExistInvoices,
        invoices_reconciliation: reconciliationInvoices,
        invoices_uploaded_successfully: uploadedSuccessfullyInvoices,
        invoices_uploaded_unsuccessful: uploadedUnsuccessfulInvoices,
      } = params.model;

      // Xử lý các invoices từ reconciliation
      if (reconciliationInvoices && reconciliationInvoices.length > 0) {
        reconciliationInvoices.forEach((invoice) => {
          this.successfullyInvoicesMap.invoices.push(invoice);
          this.successfullyInvoicesMap.total_invoices++;
        });
      }

      // Xử lý các invoices từ already exist
      if (alreadyExistInvoices && alreadyExistInvoices.length > 0) {
        alreadyExistInvoices.forEach((invoice) => {
          // Gọi đúng tên map dựa trên origin của invoice
          if (invoice.origin === '2') {
            const mapToUse = this.invalidInvoicesMap[INVOICE_TYPES.FAILED];
            mapToUse.invoices.push(invoice);
            mapToUse.total_invoices++;
            this.NoOfInvalidInvoices++;
          }
          if (invoice.origin === '4') {
            this.reconciledInvoicesMap.invoices.push(invoice);
            this.reconciledInvoicesMap.total_invoices++;
          }
        });
      }

      // Xử lý các invoices từ uploaded successfully
      if (uploadedSuccessfullyInvoices && uploadedSuccessfullyInvoices.length > 0) {
        uploadedSuccessfullyInvoices.forEach((invoice) => {
          const errorType = INVOICE_TYPES.FAILED;
          this.invalidInvoicesMap[errorType].invoices.push(invoice);
          this.invalidInvoicesMap[errorType].total_invoices++;
          this.NoOfInvalidInvoices++;
        });
      }

      // Xử lý các invoices từ uploaded unsuccessfully
      if (uploadedUnsuccessfulInvoices && uploadedUnsuccessfulInvoices.length > 0) {
        uploadedUnsuccessfulInvoices.forEach((invoice) => {
          // Phân biệt giữa các loại lỗi nếu cần
          const errorType = INVOICE_TYPES.ERROR; // Giả sử mỗi hóa đơn không thành công đều thuộc loại 'ERROR'
          this.invalidInvoicesMap[errorType].invoices.push(invoice);
          this.invalidInvoicesMap[errorType].total_invoices++;
          this.NoOfInvalidInvoices++;
        });
      }

      // Đặt active tab dựa trên số lượng invoices
      if (this.successfullyInvoicesMap.total_invoices > 0) {
        this.activeTab = TABS.TAB_SUCCESSFULLY;
      } else if (this.reconciledInvoicesMap.total_invoices > 0) {
        this.activeTab = TABS.TAB_RECONCILED;
      } else if (this.NoOfInvalidInvoices > 0) {
        this.activeTab = TABS.TAB_INVALID;
      }
    },

    // beforeOpen(params) {
    //   this.importedInvoices = params.model.invoices_uploaded_successfully || [];
    //   this.importedInvoices.forEach((importedInvoice) => {
    //     if (!this.importedInvoiceMap) {
    //       this.importedInvoiceMap = {};
    //     }
    //     this.importedInvoiceMap[importedInvoice.invoice_type] = importedInvoice;
    //   });
    //
    //   this.verifiedInvoices = params.model.invoices_reconciliation || [];
    //   this.duplicatedInvoices = params.model.invoices_already_exist || [];
    //   this.failedInvoices = params.model.invoices_uploaded_unsuccessful || [];
    //
    //   if (this.importedInvoices.length > 0) {
    //     this.activeTab = TABS.TAB_OK;
    //   }
    //   if (this.verifiedInvoices.length > 0) {
    //     this.activeTab = TABS.TAB_VERIFY;
    //   }
    //   if (this.duplicatedInvoices.length > 0) {
    //     this.activeTab = TABS.TAB_DUPLICATED;
    //   }
    //   if (this.failedInvoices.length > 0) {
    //     this.activeTab = TABS.TAB_FAILED;
    //   }
    // },
    beforeClose() {
      this.$bus.emit('close-invoice-upload-modal');
    },
  },
};
</script>
<style lang="scss" scoped>
 .tabs-component-tabs {
   li {
     padding: 4px 12px;
     font-size: 14px;
   }
 }
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-import-result-modal.vue